import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=066642fd&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066642fd')) {
      api.createRecord('066642fd', component.options)
    } else {
      api.reload('066642fd', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=066642fd&", function () {
      api.rerender('066642fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nRp41j0RQTsn/JS/comp/IncreaseNumber.vue"
export default component.exports